import React from "react";
import { DatePicker, Table } from "antd";

import { Card, Row, Col, Button } from "react-bootstrap";
import {
  employeesTipColumn,
  TipReportSummary,
} from "./../../Table/TableColumns";
import "./TipReportPrint.css";
const List = (props) => {
  const { MonthPicker } = DatePicker;

  let totalEmployeesTip = 0;
  for (let i = 0; i < props.dataSource.length; i++) {
    totalEmployeesTip += props.dataSource[i].total;
  }

  const TipReportSummaryData = [
    {
      title: "TipReportSummaryData",
    },
  ];

  const printReportHandler = () => {
    window.print();
  };

  return (
    <>
      <Card>
        <Card.Body>
          <Row className="text-center">
            <Col>
              <h5>TIP-REPORT</h5>
            </Col>

            <Col className="ml-3">
              <DatePicker
                id="TipDate"
                onChange={(date, dateString) => {
                  
                  props.handleDateChange(date, "day");
                }}
                format="YYYY-MM-DD"
                placeholder="Select Day"
              ></DatePicker>
            </Col>
            <Col>
              <MonthPicker
                onChange={(date, dateString) => {
                  props.handleMonthChange(date, "month");
                }}
                placeholder="Select Month"
              />
            </Col>
            <Col align="right" className="mr-5">
              <Button
                onClick={() => printReportHandler()}
                className="ant-btn btn-ab" style={{background:"#dcbb68"}}
              >
                <i
                  className="fa fa-print"
                  style={{ fontSize: 20, marginTop: 1 }}
                  aria-hidden="true"
                />
              </Button>
            </Col>
          </Row>
          <Row className="mt-3" >
            <Col>
              <Table
                id="TipTable"
                loading={props.isLoading}
                dataSource={props.dataSource}
                columns={employeesTipColumn()}
                footer={
                  props.dataSource.length > 0
                    ? () => (
                        <>
                          <Table
                            dataSource={TipReportSummaryData}
                            columns={TipReportSummary(totalEmployeesTip)}
                            showHeader={false}
                            pagination={false}
                            rowClassName="highlighted-bg"
                            rowKey={props.rowKey}
                          />
                        </>
                      )
                    : ""
                }
                className="ant-table-body"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default List;
